import {
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
} from '@angular/core';
import { ApiCore } from 'src/app/config/api';
import { AppConstants } from 'src/app/config/constants';
import { AuthService } from 'src/app/core/auth/auth.service';
import { ApiService } from 'src/app/core/http/api.service';
import { EventMenuProfileService } from '../profile-menu/profile-menu.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-profile-icon',
  templateUrl: './profile-icon.component.html',
  styleUrls: ['./profile-icon.component.css'],
})
export class ProfileIconComponent implements OnInit {
  public showProfileMenu: boolean = false;
  public profilePicture: string = AppConstants.IMAGE_AVATAR_DEFAULT;
  @Input() isPCPlayer: boolean = false;

  @Input() showLoadSkeleton: boolean = false;

  constructor(
    private readonly api: ApiService,
    private readonly auth: AuthService,
    private readonly elementRef: ElementRef,
    private readonly eventMenuProfileService: EventMenuProfileService,
    private readonly router: Router
  ) {
    this.eventMenuProfileService.$eventNewPicture.subscribe((url) => {
      this.profilePicture =
        url.length === 0 ? AppConstants.IMAGE_AVATAR_DEFAULT : url;
    });
  }

  ngOnInit(): void {
    this.loadUserInfo();
  }

  private loadUserInfo(): void {
    this.api.list(ApiCore.USER + '/me').subscribe({
      next: (res) => {
        this.profilePicture = res.data.profilePictureUrl ?? this.profilePicture;
      },
      error: () => {
        console.error('Su sesión expiró o no ha iniciado sesión');
        // this.auth.destroySession();
        // this.router.navigate(['/'], {
        //   state: {
        //     anotherBrowser:
        //       'Su sesión fue cerrada. Se inició sesión en otro dispositivo o navegador',
        //   },
        // });
      },
    });
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.showProfileMenu = false;
    }
  }

  toggleProfile() {
    this.showProfileMenu = !this.showProfileMenu;
  }
}
